'use strict';

var _ = require('lodash');
var ConfigurationParametersAdvancedTransformerFactory = function ConfigurationParametersAdvancedTransformerFactory(DataTransformer, momentService, idService, advancedHepTransformationService) {
  var MAX_DTD = 365;
  var readingTimeRegex = /(\d+)d \d+h \d+m/;
  function ConfigurationParametersAdvancedTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-parameters-advanced-mode';
    this.priority = 1;
  }
  ConfigurationParametersAdvancedTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationParametersAdvancedTransformer.constructor = ConfigurationParametersAdvancedTransformer;
  ConfigurationParametersAdvancedTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationParametersAdvancedTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationParametersAdvancedTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  var propertyValuesMapping = {
    //SlackDistributionMethodEMSRConfig
    PROTECTION: 'Distribute slack to the classes in proportion to class protections',
    NO_DISTRIBUTION: 'No slack distribution',
    TOP: 'Distribute slack to top class',
    TOP3OPEN: 'Distribute slack to the top 3 open classes',
    REMAINING_DEMAND: 'Distribute slack to the classes in proportion to class remaining demand',
    CER: 'Distribute slack to the classes in proportion to class CER',
    BOTTOM3OPEN: 'Distribute slack to the bottom 3 open classes',
    //BidPriceCurveConfig
    BP_BACKWARD_CURVE_FLOOR: 'Backward Curve Floor',
    BP_FLOOR: 'Entire Curve Floor',
    NO_CAPPING: 'No Flooring',
    //DA_RIAWeights
    ROUNDTRIP: 'Round Trip',
    ONEWAY: 'One-Way'
  };
  function sortByReadingTimeIntervalsFromHighest(property) {
    return _.sortBy(property, function (item) {
      if (!_.isUndefined(item.readingTimeInterval)) {
        var dayParsed = item.readingTimeInterval.match(readingTimeRegex);
        return parseInt(dayParsed[1]);
      }
      return -1;
    });
  }
  function prepareReadingTimeInterval(props, type) {
    _.forOwn(props, function (property) {
      var previousEnd = MAX_DTD + 1;
      property = sortByReadingTimeIntervalsFromHighest(property);
      for (var i = property.length - 1; i >= 0; i--) {
        var item = property[i];
        convertPropertyValues(item, type);
        if (!_.isUndefined(item.readingTimeInterval)) {
          var m = item.readingTimeInterval.match(readingTimeRegex);
          item.readingTimeIntervalStart = parseInt(m[1]);
          item.readingTimeIntervalEnd = previousEnd - 1;
          previousEnd = item.readingTimeIntervalStart;
        }
      }
    });
  }
  function convertPropertyValues(item, type) {
    if (type === 'SlackDistributionMethodEMSRConfig') {
      item.method = propertyValuesMapping[item.method];
    } else if (type === 'BidPriceCurveConfig') {
      item.bidPriceCappingMethod = propertyValuesMapping[item.bidPriceCappingMethod];
    } else if (type === 'DA_RIAWeights') {
      item.tripType = propertyValuesMapping[item.tripType];
    }
  }
  function convertAttributesValues(item, type) {
    if (type === 'DA_RIAWeights') {
      item.tripType = propertyValuesMapping[item.tripType];
      item.advancedPurchaseFrom = parseInt(item.advancedPurchaseFrom);
      item.advancedPurchaseTo = parseInt(item.advancedPurchaseTo);
      item.lengthOfStayFrom = parseInt(item.lengthOfStayFrom);
      item.lengthOfStayTo = parseInt(item.lengthOfStayTo);
    }
  }
  function formatMaxDepartureTimeWindow(item) {
    item.maxDepartureTimeWindow = _.replace(item.maxDepartureTimeWindow, /\s*\d*d\s/, '');
    return item;
  }
  function transformRTP(rtps) {
    return {
      readingDays: _.map(rtps.readingDays, 'days')
    };
  }
  function parseLegId(attrs) {
    if (!_.isUndefined(attrs) && !_.isUndefined(attrs.legId)) {
      var result = idService.parseLegId(attrs.legId);
      result.departureDate = momentService.of(result.departureDate, momentService.FIELD.DEPARTURE_DATE);
      return _.chain(attrs).omit('legId').assign(result).value();
    }
    return attrs;
  }
  function parseDates(attrs) {
    if (attrs) {
      var dateTypeAttrs = [{
        name: 'legDepartureDateBegin',
        momentConfig: momentService.FIELD.ND_DEPARTURE_DATE
      }, {
        name: 'legDepartureDateEnd',
        momentConfig: momentService.FIELD.ND_DEPARTURE_DATE
      }, {
        name: 'runDateBegin',
        momentConfig: momentService.FIELD.OPTIMIZATION_RUN_DATE
      }, {
        name: 'runDateEnd',
        momentConfig: momentService.FIELD.OPTIMIZATION_RUN_DATE
      }, {
        name: 'travelDateBegin',
        momentConfig: momentService.FIELD.TRAVEL_DATE
      }, {
        name: 'travelDateEnd',
        momentConfig: momentService.FIELD.TRAVEL_DATE
      }];
      for (var attributeName in attrs) {
        var dateType = _.find(dateTypeAttrs, {
          name: attributeName
        });
        if (dateType) {
          attrs[attributeName] = momentService.of(attrs[attributeName], dateType.momentConfig);
        }
      }
    }
    return attrs;
  }
  function getLastUpdated(hepEntry) {
    return {
      lastUpdatedBy: hepEntry.lastUpdatedBy,
      lastUpdatedAt: momentService.of(hepEntry.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT)
    };
  }
  function unwindDataForNestedHeps(hepList) {
    if (!_.isUndefined(hepList)) {
      var meta = _.pick(hepList[0], ['type', 'hepKey']);
      if (meta.type === 'FOTacticalUserOverrides') {
        return unwindFOTacticalUserOverrideHep(hepList);
      }
    }
    return hepList;
  }
  function unwindFOTacticalUserOverrideHep(hepList) {
    var unwindedHepList = [];
    _.forEach(hepList, function (hep) {
      if (!_.isUndefined(hep.properties.foTacticalFareBrandUserOverrideProperties) && hep.properties.foTacticalFareBrandUserOverrideProperties.length > 0) {
        var foTacticalFareBrandUserOverrideProperties = _.cloneDeep(hep.properties.foTacticalFareBrandUserOverrideProperties);
        delete hep.properties.foTacticalFareBrandUserOverrideProperties;
        var hepClone = _.cloneDeep(hep);
        var count = 0;
        _.forEach(foTacticalFareBrandUserOverrideProperties, function (foTacticalFBProperty) {
          var clone = count === 0 ? hep : _.cloneDeep(hepClone);
          clone.properties.hostFareBrand = foTacticalFBProperty.hostFareBrand;
          clone.properties.outboundWeekendDefinition = foTacticalFBProperty.outboundWeekendDefinition;
          clone.properties.inboundWeekendDefinition = foTacticalFBProperty.inboundWeekendDefinition;
          clone.properties.advancePurchase = foTacticalFBProperty.advancePurchase;
          clone.properties.inboundProactiveBlackouts = foTacticalFBProperty.inboundProactiveBlackouts;
          clone.properties.outboundProactiveBlackouts = foTacticalFBProperty.outboundProactiveBlackouts;
          clone.properties.inboundTimeOfDayDefinition = foTacticalFBProperty.inboundTimeOfDayDefinition;
          clone.properties.outboundTimeOfDayDefinition = foTacticalFBProperty.outboundTimeOfDayDefinition;
          clone.properties.foSeasons = foTacticalFBProperty.seasons;
          unwindedHepList = count === 0 ? unwindedHepList : _.concat(unwindedHepList, [clone]);
          count++;
        });
      }
    });
    hepList = _.concat(hepList, unwindedHepList);
    return hepList;
  }
  ConfigurationParametersAdvancedTransformer.prototype.transform = function (data) {
    var hepList = _.get(data, 'domain.hepList');
    var additionalHepList = _.get(data, 'secondDomain.hepList');
    hepList = unwindDataForNestedHeps(hepList);
    return _.transform(hepList, function (result, item) {
      var attrs = parseLegId(_.get(item, 'attributes'));
      attrs = parseDates(attrs);
      var lastUpdated = getLastUpdated(item);
      var props = _.get(item, 'properties');
      var meta = _.pick(item, ['type', 'hepKey']);
      meta = _.assign(meta, lastUpdated);
      if (_.startsWith(meta.type, 'FP') || _.startsWith(meta.type, 'DA')) {
        if (attrs.pos) {
          attrs.daPos = attrs.pos;
          delete attrs.pos;
        }
      }
      if (props.flightExclusionRanges !== undefined) {
        _.forEach(props.flightExclusionRanges, function (r) {
          result.push(_.assign(r, attrs, meta));
        });
      } else if (meta.type === 'RTP') {
        result.push(_.assign(transformRTP(props), attrs, meta));
      } else if (meta.type === 'FP_MarketConfig') {
        result.push(advancedHepTransformationService.transformFpMarketConfigType(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'CurtainRule') {
        result.push(advancedHepTransformationService.transformCurtainRuleType(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOBusinessRules') {
        result.push(advancedHepTransformationService.transformFOBusinessRulesType(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOMinStayGrouping') {
        result.push(advancedHepTransformationService.transformAttributeNameToFOAttributeName(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOMaxStayGrouping') {
        result.push(advancedHepTransformationService.transformAttributeNameToFOAttributeName(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOTaxOverride') {
        result.push(advancedHepTransformationService.transformFOTaxOverride(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FONoticePeriod') {
        result.push(advancedHepTransformationService.transformFONoticePeriodType(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOInputDataComparisonChecks') {
        result.push(advancedHepTransformationService.transformFOInputDataComparisonChecksType(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOAdvancePurchaseGrouping') {
        result.push(advancedHepTransformationService.transformFOAdvancePurchaseGrouping(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOViaPoints') {
        result.push(advancedHepTransformationService.transformFOViaPoints(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOCabinClassConfig') {
        result.push(advancedHepTransformationService.transformFOCabinClassConfig(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOSeasonLevelMatchThreshold') {
        result.push(advancedHepTransformationService.transformAttributeNameToFOAttributeName(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOUpSellBuyDownConfig') {
        result.push(advancedHepTransformationService.transformFOUpSellBuyDownConfig(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOMarketList') {
        _.forEach(advancedHepTransformationService.transformFOMarketList(props, meta), function (market) {
          result.push(market);
        });
      } else if (meta.type === 'FOFareBrandDefinitionConfig') {
        _.forEach(advancedHepTransformationService.transformFOFareBrands(props, meta), function (fareBrand) {
          result.push(fareBrand);
        });
      } else if (meta.type === 'FORBDLevelFareThreshold') {
        result.push(advancedHepTransformationService.transformFORbdLevelFareThreshold(attrs, props, meta, additionalHepList));
      } else if (meta.type === 'FOFareClassMapping') {
        result.push(advancedHepTransformationService.transformFOFareClassMapping(attrs, props, meta));
      } else if (meta.type === 'FOAnalystPosMapping') {
        result.push(advancedHepTransformationService.transformFOPosAnalystMapType(attrs, props, meta));
      } else if (meta.type === 'FOTacticalFareIndex') {
        result.push(advancedHepTransformationService.transformFOTacticalFareIndexType(attrs, props, meta));
      } else if (meta.type === 'FOTacticalUserOverrides') {
        result.push(advancedHepTransformationService.transformFOTacticalUserOverridesType(attrs, props, meta));
      } else if (meta.type === 'FOFareBrandAssignment') {
        result.push(advancedHepTransformationService.transformFOFareBrandAssignment(attrs, props, meta));
      } else if (meta.type === 'FOTacticalFareDefinition') {
        result.push(advancedHepTransformationService.transformFOTacticalFareDefinition(attrs, props, meta));
      } else if (meta.type === 'DA_FareFloorCeiling') {
        result.push(advancedHepTransformationService.transformDAFareFloor(attrs, props, meta));
      } else if (meta.type === 'FOTacticalFBCPatternConfig') {
        _.forEach(advancedHepTransformationService.transformFOTacticalFBCPatternConfig(attrs, props, meta), function (market) {
          result.push(market);
        });

        // if every field is object, then we have grouped props else simple value
      } else if (meta.type === 'FOSurchargeManagement') {
        result.push(advancedHepTransformationService.transformAttributeNameToFOAttributeName(attrs, props, meta));
      } else if (!_.isEmpty(props) && _.every(props, _.isArray)) {
        prepareReadingTimeInterval(props, item.type);
        result.push(_.assign(props, attrs, meta));
      } else if (!_.isEmpty(props) && _.every(_.values(props), _.isObject)) {
        var propKey = _.chain(props).keys().head().value();
        var generatedProp = _.mapKeys(props[propKey], function (obj, key) {
          key = key.split('-').join('_');
          return [propKey, key].join('_');
        });
        advancedHepTransformationService.transformBooleanValues(generatedProp);
        advancedHepTransformationService.transformNumberAttributes(attrs, meta.type);
        result.push(_.assign(generatedProp, attrs, meta));
      } else if (item.type === 'MaxDepartureTimeWindow') {
        result.push(_.assign(formatMaxDepartureTimeWindow(props), attrs, meta));
      } else {
        convertAttributesValues(attrs, meta.type);
        result.push(_.assign(props, attrs, meta));
      }
      return result;
    }, []);
  };
  return ConfigurationParametersAdvancedTransformer;
};
ConfigurationParametersAdvancedTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'IdService', 'AdvancedHepTransformationService'];
module.exports = ConfigurationParametersAdvancedTransformerFactory;